"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIntendedActions = exports.getPricingByExternalId_bff = exports.getPricingV2_bff = exports.getPricing_bff = exports.defaultIntendedActions = void 0;
var tslib_1 = require("tslib");
/* eslint-disable  @typescript-eslint/camelcase */
var interfaces_1 = require("../interfaces");
var interfaces_2 = require("../../common/interfaces");
var index_1 = require("../index");
var common_1 = require("../../common");
var interfaces_3 = require("../../common/interfaces");
exports.defaultIntendedActions = [
    interfaces_1.IntendedActions.JOIN,
    interfaces_1.IntendedActions.RESUBSCRIBE,
    interfaces_1.IntendedActions.RESUME,
    interfaces_1.IntendedActions.REVOKE_PENDING_CANCEL,
    interfaces_1.IntendedActions.REVOKE_PENDING_PAUSE
];
function getPricing_bff(product, requestOptions) {
    if (requestOptions === void 0) { requestOptions = {
        timeout: interfaces_1.PRICING_TIMEOUT
    }; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var internalRequestPayload, request, response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    internalRequestPayload = product.internalRequestPayload;
                    delete product.internalRequestPayload;
                    product = (0, index_1.cleanInputExperiment)(product);
                    request = {
                        input: tslib_1.__assign(tslib_1.__assign({}, product), { countryCode: "US", intendedActions: tslib_1.__spreadArray([], tslib_1.__read(exports.defaultIntendedActions), false) }),
                        dataRequested: interfaces_1.Commands.ELIGIBILITY,
                        desiredOrderStatuses: [],
                        billing: { country: "US" }
                    };
                    return [4 /*yield*/, (0, common_1.sendBFFCall)(interfaces_3.GraphQLOperations.GET_PRICING_BY_EXTERNALID, request, getPricingV2ResponseFormatter, undefined, requestOptions.timeout, internalRequestPayload).catch(function (error) { return JSON.parse(error.message); })];
                case 1:
                    response = _a.sent();
                    if (response.success) {
                        response.data = response.data.eligibility;
                    }
                    return [2 /*return*/, response];
            }
        });
    });
}
exports.getPricing_bff = getPricing_bff;
function getPricingV2_bff(product, requestOptions) {
    if (requestOptions === void 0) { requestOptions = {
        timeout: interfaces_1.PRICING_TIMEOUT
    }; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var internalRequestPayload, pricePlanInput, productCode, countryCode, offerId, experiment, dataRequested, openToUpgrade, intendedActions, billing, anonymous, derivedDataRequested, request, response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    internalRequestPayload = product.internalRequestPayload, pricePlanInput = product.pricePlanInput;
                    delete product.pricePlanInput;
                    delete product.internalRequestPayload;
                    product = (0, index_1.cleanInputExperiment)(product);
                    productCode = product.productCode, countryCode = product.countryCode, offerId = product.offerId, experiment = product.experiment, dataRequested = product.dataRequested, openToUpgrade = product.openToUpgrade, intendedActions = product.intendedActions, billing = product.billing, anonymous = product.anonymous;
                    derivedDataRequested = (0, common_1.processBFFDataRequested)(dataRequested || interfaces_1.Commands.ELIGIBILITY_V2);
                    request = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ input: {
                            anonymous: anonymous || false,
                            countryCode: countryCode,
                            offerId: offerId,
                            experiment: experiment,
                            productCode: productCode,
                            intendedActions: getIntendedActions({
                                intendedActions: intendedActions,
                                openToUpgrade: openToUpgrade,
                                orderStatuses: derivedDataRequested.desiredOrderStatuses
                            })
                        } }, derivedDataRequested), { billing: billing || { country: countryCode } }), (pricePlanInput && { pricePlanInput: pricePlanInput }));
                    return [4 /*yield*/, (0, common_1.sendBFFCall)(interfaces_3.GraphQLOperations.GET_PRICING_V2, request, getPricingV2ResponseFormatter, undefined, requestOptions.timeout, internalRequestPayload).catch(function (error) { return JSON.parse(error.message); })];
                case 1:
                    response = _a.sent();
                    if (response.success) {
                        response.data = tslib_1.__assign(tslib_1.__assign({}, response.data), { productFamily: productCode, offerId: offerId });
                    }
                    return [2 /*return*/, response];
            }
        });
    });
}
exports.getPricingV2_bff = getPricingV2_bff;
function getPricingByExternalId_bff(product, requestOptions) {
    var _a, _b;
    if (requestOptions === void 0) { requestOptions = {
        timeout: interfaces_1.PRICING_TIMEOUT
    }; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var internalRequestPayload, pricePlanInput, productCode, countryCode, experiment, itemId, dataRequested, billing, intendedActions, anonymous, derivedDataRequested, country, request, response;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    internalRequestPayload = product.internalRequestPayload, pricePlanInput = product.pricePlanInput;
                    delete product.internalRequestPayload;
                    delete product.pricePlanInput;
                    product = (0, index_1.cleanInputExperiment)(product);
                    productCode = product.productCode, countryCode = product.countryCode, experiment = product.experiment, itemId = product.itemId, dataRequested = product.dataRequested, billing = product.billing, intendedActions = product.intendedActions, anonymous = product.anonymous;
                    derivedDataRequested = (0, common_1.processBFFDataRequested)(dataRequested || interfaces_1.Commands.ELIGIBILITY_PAUSED_PENDING_CANCEL);
                    country = countryCode || "US";
                    request = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ input: {
                            anonymous: anonymous || false,
                            countryCode: country,
                            itemId: itemId,
                            experiment: experiment,
                            productCode: productCode,
                            intendedActions: getIntendedActions({
                                intendedActions: intendedActions,
                                orderStatuses: derivedDataRequested.desiredOrderStatuses
                            })
                        } }, derivedDataRequested), { billing: billing || { country: country } }), (pricePlanInput && { pricePlanInput: pricePlanInput }));
                    return [4 /*yield*/, (0, common_1.sendBFFCall)(interfaces_3.GraphQLOperations.GET_PRICING_BY_EXTERNALID, request, getPricingV2ResponseFormatter, undefined, requestOptions.timeout, internalRequestPayload).catch(function (error) { return JSON.parse(error.message); })];
                case 1:
                    response = _c.sent();
                    if (response.success) {
                        response.data = tslib_1.__assign(tslib_1.__assign({}, response.data), { countryCode: ((_a = response.data.getPricingByExternalId) === null || _a === void 0 ? void 0 : _a.countryCode) || country, productFamily: productCode, externalId: ((_b = response.data.getPricingByExternalId) === null || _b === void 0 ? void 0 : _b.externalId) || itemId, offerId: [] });
                    }
                    return [2 /*return*/, response];
            }
        });
    });
}
exports.getPricingByExternalId_bff = getPricingByExternalId_bff;
function getPricingV2ResponseFormatter(responseParams) {
    return responseParams.then(function (result) {
        var _a;
        var data = result.data, errors = result.errors, success = result.success;
        var pricingData = data.getPricingV2 || data.getPricingByExternalId;
        var authState = data.getAuthState;
        var _b = pricingData.item, eligibility = _b.eligibility, externalId = _b.externalId, countryCode = pricingData.countryCode, networkInfo = pricingData.networkInfo;
        var price = eligibility.price, order = eligibility.order, finalActions = eligibility.finalActions, currencyDetails = eligibility.currencyDetails;
        if (currencyDetails &&
            currencyDetails.currencyCode === "GBP" &&
            currencyDetails.currencyName) {
            currencyDetails.currencyName += " Sterling";
            eligibility.currencyDetails = currencyDetails;
        }
        var taxQuote = (price || {}).taxQuote;
        if (price) {
            delete price.taxQuote;
        }
        if (!(order === null || order === void 0 ? void 0 : order.lineItem)) {
            eligibility.order = null;
        }
        if (order === null || order === void 0 ? void 0 : order.orderDetails) {
            var paymentMethod = order.orderDetails.paymentMethod;
            delete eligibility.order.orderDetails.paymentMethod;
            var mopDetails = (_a = order.orderDetails.mopDetails) !== null && _a !== void 0 ? _a : null;
            delete eligibility.order.orderDetails.mopDetails;
            eligibility.order = tslib_1.__assign(tslib_1.__assign({}, order), { details: order.orderDetails, paymentMethod: paymentMethod, mopDetails: mopDetails });
            delete eligibility.order.orderDetails;
        }
        else if (eligibility.order) {
            delete eligibility.order.orderDetails;
        }
        var responseObj = {
            data: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ authState: authState, nextInteraction: null, countryCode: countryCode, externalId: externalId, eligibility: eligibility }, (data.getPricingV2 && { taxQuote: null })), (taxQuote && { taxInfo: taxQuote })), { actions: (finalActions.length > 0 && finalActions[0]) || "", networkInfo: networkInfo }),
            errors: errors,
            success: success
        };
        return responseObj;
    });
}
function getIntendedActions(data) {
    var intendedActions = data.intendedActions || tslib_1.__spreadArray([], tslib_1.__read(exports.defaultIntendedActions), false);
    var openToUpgrade = data.openToUpgrade, orderStatuses = data.orderStatuses;
    if (openToUpgrade && !intendedActions.includes(interfaces_1.IntendedActions.UPGRADE)) {
        intendedActions.push(interfaces_1.IntendedActions.UPGRADE);
    }
    if (orderStatuses.includes(interfaces_2.OrderStates.PENDING_PAUSE) &&
        !intendedActions.includes(interfaces_1.IntendedActions.REVOKE_PENDING_PAUSE)) {
        intendedActions.push(interfaces_1.IntendedActions.REVOKE_PENDING_PAUSE);
    }
    return intendedActions;
}
exports.getIntendedActions = getIntendedActions;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/modules/pricingApi/bff/index.js
// module id = 3404
// module chunks = 11